
const visibilityFilter = (state = { selected: [] }, action) => {
  switch (action.type) {
    case 'SET_VISIBILITY_FILTER': {
      let filtersSelected = [...state.selected, action.filter];
      let checkUniques = filtersSelected.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          parseInt(t.filter.id, 10) === parseInt(thing.filter.id, 10)
        ))
      );

      return {
        selected: checkUniques
      }
    }
    case 'REMOVE_VISIBILITY_FILTER': {
      let removeFilters = state.selected.filter( (fil) => fil.filter !== action.filter.filter);
      return {
        selected: removeFilters
      }
    }
    default: {
      return state
    }
  }
}

export default visibilityFilter


// WEBPACK FOOTER //
// ./src/reducers/FilterReducer.js